module.exports = __webpack_public_path__ + "img/ctrl-yy-1.97c97ae3.svg";